import { useActionMutation, type UseMutationProps } from '@ztechapps/common.hook'
import type { Blog, CancelBlogTranscriptionJobArgs } from '@ztechapps/common.contract'
import { cancelBlogTranscriptionJobMutation } from '../graphql/cancelBlogTranscriptionJob'

/**
 * Hook to cancel a running blog transcription job.
 *
 * @example
 * ```tsx
 * const [cancelJob, { loading, error }] = useCancelBlogTranscriptionJob()
 *
 * const handleCancel = async () => {
 *   const blog = await cancelJob({ blogId: 'blog-123' })
 *   if (blog?.transcribingMetadata?.status === 'cancelled') {
 *     console.log('Job cancelled successfully')
 *   }
 * }
 * ```
 */
export const useCancelBlogTranscriptionJob = ({ query, ...props } = {} as UseMutationProps) => {
  query = query ?? cancelBlogTranscriptionJobMutation

  return useActionMutation<Blog, CancelBlogTranscriptionJobArgs>({
    query,
    ...props,
  })
}
